import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $HitNewLandingModalStyle } from '~/utils/libra/landing-modal-style';
import { LandingModal } from '../landing-modal';
import { LandingModalStyle } from '../landing-modal-style';
import {$USPreBanState } from '@lemon8/web-app-shared/atom';

export const LandingModalTest: FC = () => {
  const hitNewLandingModalStyle = useAtomValue($HitNewLandingModalStyle);
  const hitUSBan = useAtomValue($USPreBanState);

  if (hitUSBan) {
    return null;
  }

  return hitNewLandingModalStyle ? <LandingModalStyle /> : <LandingModal />;
};
